import React, { ReactElement } from 'react';
import { styled } from '@superset-ui/core';

import { Card, CardType } from '../../types';
import SectionHeader from '../SectionHeader/SectionHeader';
import ThumbnailCard from '../ThumbnailCard/Card';
import IconCard from '../IconCard/Card';

interface Props {
    title: string;
    buttonText?: string;
    buttonIcon?: any;
    cards: Card[];
    lastCard?: ReactElement;
    handleBtnClick?: () => any;
    handleCardClick?: (card: Card) => any;
}

const StyledDiv = styled.div`
display: flex;
flex-direction: column;

.listRow {
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: stretch;
    gap: 1.5em;
    padding: 2rem 1.7rem;
    overflow: auto;

    &::-webkit-scrollbar {  
        background-color: transparent;
    }

    &::-webkit-scrollbar-thumb {
        background: transparent;
    }
}

.listRow:hover {
    ::-webkit-scrollbar-thumb {
        background:rgba(210, 211, 212, 0.52);
    }
}
`;

const Card = (props: Props) => {

    const cardList = props.cards.map(card => {
        return ( card.type === CardType.Thumbnail ?
          <div
                key={`${card.cardLabel}-${card.id}`}
                onClick={() => props.handleCardClick && props.handleCardClick(card)}>
                <ThumbnailCard
                        key={`${card.cardLabel}-${card.id}`}
                        title={card.title}
                        subTitle={card.subTitle}
                        iconLabel={card.cardLabel}
                        labelIcon={card.labelIcon}
                        thumbnailUrl={card.thumbnailUrl}
                        placeholderImage={card.placeholderImage}
                    />
          </div>
          :
          <div
                key={`${card.cardLabel}-${card.id}`}
                onClick={() => props.handleCardClick && props.handleCardClick(card)}>
                <IconCard
                    key={`${card.cardLabel}-${card.id}`}
                    title={card.title}
                    subTitle={card.subTitle}
                    iconLabel={card.cardLabel}
                    labelIcon={card.labelIcon}
                    cardIcon={card.icon}
                    hoverIcon={card.hoverIcon}
                    />
          </div>
        )
    });

    if (props.lastCard) {
        cardList.push(
            props.lastCard
        );
    }

    return (
        <StyledDiv>
            <SectionHeader
                title={props.title}
                buttonText={props.buttonText}
                buttonIcon={props.buttonIcon}
                handleBtnClick={props.handleBtnClick}
                />
            <div className='listRow'>
                {
                    cardList
                }
            </div>
        </StyledDiv>
    );
};

export default Card;
